<template>

  <q-markup-table flat cellpadding="0" cellspacing="0" class="full-width bg-grey-2">

    <tbody>
    <tr>
      <td>
        <div class="text-bold">Monthly Usage</div>
        <div>Enter or select a usage</div>
      </td>
      <td :class="{'bg-white': is_custom}" class="text-center">
        <q-input v-model="custom_usage_amount" label="Custom" @focus="select_usage(custom_usage_amount)"
                 input-class="text-right" ref="custom_usage_input" type="tel"
                 mask="#####" suffix="kWh" @keyup.enter="select_usage(custom_usage_amount)"
                 @blur="select_usage(custom_usage_amount)" style="min-width: 100px">
        </q-input>
      </td>
      <td v-for="usage in standard_usages" @click="select_usage(usage)" :class="{'bg-white': is_selected(usage)}"
          class="cursor-pointer text-bold text-blue-grey-5">
        <div class="q-px-md q-py-xs text-center"
             :class="{'text-white': is_selected(usage), 'bg-black': is_selected(usage), 'bg-white': !is_selected(usage), 'text-black': !is_selected(usage)}">
          {{ usage }} kWh
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="text-bold">Total charges on your bill*</div>
      </td>
      <td @click="select_usage(custom_usage_amount)" :class="{'bg-white': is_custom}"
          class="cursor-pointer text-bold text-blue-grey-5">
        <div class="text-center" :class="{'text-accent': is_custom}">
          ${{ format_dollar_amount(plan[`display_pricing_${custom_usage_amount}`]?.total) || '---' }}
        </div>
      </td>
      <td v-for="usage in standard_usages" @click="select_usage(usage)"
          class="cursor-pointer text-bold text-blue-grey-5"
          :class="{'bg-white': is_selected(usage)}">
        <div class="text-center text-accent">
          ${{ format_dollar_amount(plan[`display_pricing_${usage}`]?.total) || '---' }}
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <span class="text-bold">Average price per kWh</span><br>
        (total ÷ usage)
      </td>
      <td @click="select_usage(custom_usage_amount)" class="cursor-pointer text-bold text-blue-grey-5"
          :class="{'bg-white': is_custom}">
        <div class="text-center" :class="{'text-accent': is_custom}">
          {{ plan[`display_pricing_${custom_usage_amount}`]?.avg_cents.toFixed(1) || '---' }}¢
        </div>
      </td>
      <td v-for="usage in standard_usages" @click="select_usage(usage)"
          class="cursor-pointer text-bold text-blue-grey-5"
          :class="{'bg-white': is_selected(usage)}">
        <div class="text-center text-accent">
          {{ plan[`display_pricing_${usage}`]?.avg_cents.toFixed(1) }}¢
        </div>
      </td>
    </tr>
    </tbody>
  </q-markup-table>
</template>

<script>
import Plans from "src/composables/Plans";
import { computed, onMounted, ref } from "vue";
import UsageFilters from "src/composables/UsageFilters";
import Utilities from "src/composables/Utilities";

export default {
  name: "SingleUsageSelector",
  props: {
    plan: {
      type: Object,
      required: true
    },
    modelValue: {
      type: Number
    }
  },
  setup(props, { emit }) {

    const { calculate_plan_for_usage } = Plans();
    const { usage_options } = UsageFilters();
    const { format_dollar_amount } = Utilities();
    const custom_usage_input = ref(null);

    const is_custom = ref(false);
    const standard_amount = ref(500);
    const custom_usage_amount = ref(null);

    const selected_usage = computed({
      get: () => props.modelValue,
      set: (val) => emit('update:modelValue', val)
    })

    onMounted(() => {
      select_usage(props.modelValue)
    })

    const standard_usages = ref([500, 1000, 2000]);

    const is_selected = (val) => !is_custom.value && standard_amount.value === val;

    const select_usage = async function (val) {
      if (val) {
        val = parseInt(val);
        if (!props.plan[`display_pricing_${val}`]) {
          const pricing = await calculate_plan_for_usage({ plan_id: props.plan._id, usage: val });
          props.plan[`display_pricing_${val}`] = pricing;
        }

        const found_standard = standard_usages.value.find(x => x === val);
        if (found_standard) {
          is_custom.value = false;
          standard_amount.value = val;
        }
        else {
          is_custom.value = true;
          custom_usage_amount.value = val;
        }

        selected_usage.value = val;
      }
      else {
        custom_usage_input.value.focus()
      }
    }

    return {
      usage_options,
      is_custom,
      is_selected,
      custom_usage_amount,
      standard_amount,
      standard_usages,
      select_usage,
      format_dollar_amount,
      custom_usage_input
    }
  }
}
</script>

<style>
.q-field--standout.q-field--rounded .q-field__control {
  border-radius: 12px;
}

body.desktop .q-focusable:focus > .q-focus-helper, body.desktop .q-manual-focusable--focused > .q-focus-helper, body.desktop .q-hoverable:hover > .q-focus-helper {
  background: rgb(3, 169, 244);
}
</style>
